let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fGPCC")).then(() => parcelRequire('d9A0j'));